/**
 * Custom error for when a signup attempt uses an email that already exists.
 * Components can check `instanceof EmailAlreadyRegisteredError` to show
 * a specific Mantine notification instead of a generic toast.
 */
export class EmailAlreadyRegisteredError extends Error {
  constructor() {
    super('Email Already Registered')
    this.name = 'EmailAlreadyRegisteredError'
  }
}
